import { render, staticRenderFns } from "./DisabledForm.vue?vue&type=template&id=b838fdac"
import script from "./DisabledForm.vue?vue&type=script&lang=js"
export * from "./DisabledForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports